import { render, staticRenderFns } from "./GestionMembresias.vue?vue&type=template&id=2bb8c0b2&scoped=true"
import script from "./GestionMembresias.vue?vue&type=script&lang=js"
export * from "./GestionMembresias.vue?vue&type=script&lang=js"
import style0 from "./GestionMembresias.vue?vue&type=style&index=0&id=2bb8c0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8c0b2",
  null
  
)

export default component.exports